"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateComponent = exports.dateTooltipFormatMap = void 0;
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var Tooltip_1 = require("../Tooltip");
// eslint-disable-next-line import/no-cycle
var table_kit_1 = require("../table-kit");
exports.dateTooltipFormatMap = {
    lll: undefined,
    ll: "lll",
    LT: "LTS",
    LTS: undefined,
};
var DateComponent = function (_a) {
    var _b = _a.format, format = _b === void 0 ? "lll" : _b, time = _a.time, inputFormat = _a.inputFormat, tooltip = _a.tooltip;
    if (!time) {
        return react_1.default.createElement(Tooltip_1.WHTooltip, { title: tooltip }, table_kit_1.NO_DATA);
    }
    return (react_1.default.createElement(Tooltip_1.WHTooltip, { title: tooltip ||
            (exports.dateTooltipFormatMap[format]
                ? moment_1.default(time, inputFormat).format(exports.dateTooltipFormatMap[format])
                : "") }, moment_1.default(time, inputFormat).format(format)));
};
exports.DateComponent = DateComponent;
